import { ValueFormatterParams } from "@ag-grid-community/core";
import { DeleteOutlined } from "@ant-design/icons";
import { Modal, Tooltip } from "antd";
import useApi from "../../../hooks/useApi";
import workItemStateCategory from "../../../api/WorkItemStateCategory";
import { AGCheckbox } from "../../config/UserConfigDefs";
import { WorkItemState } from "../workitem-states/WorkItemStatesTable";
import { toast } from "react-toastify";


export const getStateCategoryDefs = ({ afterUpdate, selectedProduct, workItemStates }: any) => {

    const ActionButton = (props: ValueFormatterParams<any, any>) => {
        const deleteStateCategoryApi = useApi(workItemStateCategory.deleteStateCategory)

        const handleOk = async () => {
            const isAssociated = workItemStates.find((item: WorkItemState) => item?.category === props?.data?.name)
            if (isAssociated) {
                toast.error(`You can not delete ${props?.data?.name} state category as it is associated with different state.`)
            } else {
                const response = await deleteStateCategoryApi.request(selectedProduct, `${props?.data?.id}`)
                if (response?.data) {
                    afterUpdate();
                }
            }

        }

        const handleAction = () => {
            Modal.confirm({
                title: `Do you want to delete ${props?.data?.name} state category?`,
                content: "This action cannot be undone.",
                okText: "Yes",
                cancelText: "No",
                onOk: () => {
                    handleOk()
                },
            });
        };

        return (
            <>
                <Tooltip title={'Delete'}>
                    {props?.data?.id >= 0 ? <DeleteOutlined onClick={() => handleAction()} /> : null}
                </Tooltip>
            </>
        )
    }

    let columns = [
        {
            headerName: 'Order',
            field: 'orderId',
            headerTooltip: "Order",
            tooltipField: "orderId",
            cellStyle: { "cursor": "pointer" },
            cellClass: 'border-right',
            show: true,
            filter: 'agMultiColumnFilter',
            menuTabs: ['filterMenuTab', 'generalMenuTab'],
            valueGetter: (params:any) => params?.data?.name ?  params.node.rowIndex + 1 : '',
        },
        {
            headerName: 'State Category Name',
            field: 'name',
            headerTooltip: "State Category Name",
            tooltipField: "name",
            cellStyle: { "cursor": "pointer" },
            cellClass: 'border-right',
            show: true,
            filter: 'agMultiColumnFilter',
            menuTabs: ['filterMenuTab', 'generalMenuTab'],
            editable: true
        },
        {
            headerName: 'Work In Progress',
            field: 'work_in_progress_state',
            headerTooltip: "Work In Progress",
            tooltipField: "work_in_progress_state",
            show: true,
            cellClass: 'border-right',
            filter: 'agMultiColumnFilter',
            menuTabs: ['filterMenuTab', 'generalMenuTab'],
            cellEditor: AGCheckbox,
            cellRenderer: AGCheckbox,
        },
        {
            field: "action",
            headerName: "",
            editable: false,
            sortable: false,
            filter: false,
            show: true,
            maxWidth: 50,
            minWidth: 50,
            resizable: false,
            cellStyle: () => { return { cursor: "pointer" } },
            cellRenderer: ActionButton,
        },
    ]

    return (
        columns
    )
}